import { createAction } from 'redux-act';

export const saveLocation = createAction();
